import dayjs from 'dayjs';
import { i18n } from '../../i18n/i18n';

const getDateWithTime = date => {
    return dayjs(date).format('D MMMM, YYYY h:mm A');
};

const getDateWithYear = dateStart => {
    return dayjs(dateStart).format('MMMM D, YYYY');
};

const getTime = date => {
    return dayjs(date).format('h:mm\u00A0a');
};

const untilDate = date => {
    return { isValid: new Date(date) > new Date() };
};

const getRelativeDate = date => {
    if (dayjs(date).isSame(dayjs(), 'day')) return i18n.t('date.today');

    return getDateWithYear(date);
};

export {
    getDateWithTime,
    getDateWithYear,
    getTime,
    untilDate,
    getRelativeDate
};
